import { useContext } from 'react'
import { SideSheetsHistoryContext } from '../context/SideSheetsHistoryContext'
import { SideSheetsNavigator } from '../typings/SideSheetsNavigator'

export function useSideSheetsNavigator(): SideSheetsNavigator {
  return useContext(SideSheetsHistoryContext)!
}
